import { useState } from 'react'
import './ImageSlider.css'

function ImageSlider({ images = [], alt = 'Imagen' }) {
  const [currentIndex, setCurrentIndex] = useState(0)

  if (!images || images.length === 0) {
    return (
      <div className="image-placeholder">
        <span>Sin imagen</span>
      </div>
    )
  }

  const goToPrevious = (e) => {
    e.stopPropagation()
    setCurrentIndex((prev) => 
      prev === 0 ? images.length - 1 : prev - 1
    )
  }

  const goToNext = (e) => {
    e.stopPropagation()
    setCurrentIndex((prev) => 
      prev === images.length - 1 ? 0 : prev + 1
    )
  }

  const goToSlide = (index, e) => {
    e.stopPropagation()
    setCurrentIndex(index)
  }

  const hasMultipleImages = images.length > 1

  return (
    <div className="image-slider">
      <div className="slider-images-container">
        {images.map((image, index) => (
          <div
            key={index}
            className={`slider-image-wrapper ${index === currentIndex ? 'active' : ''}`}
          >
            <img
              src={image}
              alt={`${alt} ${index + 1}`}
              className="slider-image"
            />
          </div>
        ))}
      </div>

      {hasMultipleImages && (
        <>
          <button
            className="slider-btn slider-btn-prev"
            onClick={goToPrevious}
            aria-label="Imagen anterior"
          >
            ‹
          </button>
          <button
            className="slider-btn slider-btn-next"
            onClick={goToNext}
            aria-label="Imagen siguiente"
          >
            ›
          </button>
          
          <div className="slider-dots">
            {images.map((_, index) => (
              <button
                key={index}
                className={`slider-dot ${index === currentIndex ? 'active' : ''}`}
                onClick={(e) => goToSlide(index, e)}
                aria-label={`Ir a imagen ${index + 1}`}
              />
            ))}
          </div>
        </>
      )}
    </div>
  )
}

export default ImageSlider
